export enum MetaDataItemPropertyType {
  Height,
  Length,
  Width,
  Weight,
}
